import { differenceInMilliseconds, parseISO } from "date-fns";
import type { Task } from "src/queries/tasks/tasks.types";

export const getTaskTimingDetails = (
  option: Task,
  minStartTime: number,
  totalDuration: number
) => {
  const startTime = parseISO(option.start_time);
  const endTime = option.end_time ? parseISO(option.end_time) : undefined;
  const minStartDate = new Date(minStartTime);

  const calcPercentage = (t1: Date | number, t2: Date | number) => {
    if (!totalDuration) return 0;
    return (differenceInMilliseconds(t1, t2) / totalDuration) * 100;
  };

  const startOffset = calcPercentage(startTime, minStartDate);
  const duration = endTime ? calcPercentage(endTime, startTime) : undefined;
  const status = option.status?.toLowerCase();

  return {
    startTime,
    endTime,
    startOffset,
    duration,
    status,
  };
};
